import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ resource, manager }) =>
    present(
      repository
        .assignManagerToResource(resource, manager)
        .then(() => ({ resource, manager }))
        .catch(() => Promise.reject({ resource, manager })),
    );
}

export type { Interactor };

export { createInteractor };
